
import { createSlice } from '@reduxjs/toolkit';
import productService from '../../../../services/product/ProductService';
import EventBus from '../../../eventBus/EventBus';
import { PRODUCT_DELETE_SUCCESS } from '../../../eventBus/productEvents/productEvents';



export const productSlice = createSlice({
    name: "product",
    initialState: {
        products: [],
        count: 0,
        filterOptions: {
            page: 1,
            limit: 10,
        },
        randomProducts: [],
        randomProductsCount: 0,
        randomFilterOptions: {
            page: 1,
            limit: 10,
        },
    },
    reducers: {
        updateFilterOptions: (state, action) => {
            state.filterOptions = action.payload
        },
        updateProducts: (state, action) => {
            state.products = action.payload
        },
        updateProductCount: (state, action) => {
            state.count = action.payload
        },
        updateRandomProducts: (state, action) => {
            state.randomProducts = action.payload
        },
        updateRandomProductCount: (state, action) => {
            state.randomProductsCount = action.payload
        },
        updateRandomFilterOptions: (state, action) => {
            state.randomFilterOptions = action.payload
        },
    }
})


export const changeFilterOptionsAsync = ({...params}) => dispatch => {
    dispatch(productSlice.actions.updateFilterOptions({...params}))
}

export const changeRandomFilterOptionsAsync = ({...params}) => dispatch => {
    dispatch(productSlice.actions.updateRandomFilterOptions({...params}))
}

export const getProductsAsync = ({page, limit, ...filters}) => dispatch => {
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}

    return new Promise((resolve, reject) => {
        productService.getProducts(params)
            .then((response) => {
                dispatch(productSlice.actions.updateProducts(response?.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getProductCountAsync = (params) => dispatch => {
    let { limit, page, ...filters} = params

    return new Promise((resolve, reject) => {
        productService.getProductCount(filters)
            .then((response) => {
                dispatch(productSlice.actions.updateProductCount(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

// random product start

export const getRandomProductsAsync = ({page, limit, ...filters}) => dispatch => {
    const skip = (page - 1) * limit
    const params = {skip, limit, ...filters}

    return new Promise((resolve, reject) => {
        productService.getRandomProducts(params)
            .then((response) => {
                dispatch(productSlice.actions.updateRandomProducts(response?.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getRandomProductCountAsync = (params) => dispatch => {
    let { limit, page, ...filters} = params

    return new Promise((resolve, reject) => {
        productService.getRandomProductCount(filters)
            .then((response) => {
                dispatch(productSlice.actions.updateRandomProductCount(response.data))
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const getRandomProductAsync = ({id}) => {
    return new Promise((resolve, reject) => {
        productService.getRandomProduct({id})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

// random product end

export const getProductAsync = ({id}) => {
    return new Promise((resolve, reject) => {
        productService.getProduct({id})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const productRegisterAsync = ({product}) => {
    return new Promise((resolve, reject) => {
        productService.productRegister({product})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const productDeleteAsync = ({id}) => {
    return new Promise((resolve, reject) => {
        productService.productDelete({id})
            .then((response) => {
                EventBus.dispatch(PRODUCT_DELETE_SUCCESS)
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}

export const productUpdateAsync = ({id, product}) => {
    return new Promise((resolve, reject) => {
        productService.productUpdate({id, product})
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                console.log(error);
                // reject(error)
            })
    })
}


export const selectProducts = state => state.product.products
export const selectProductCount = state => state.product.count
export const selectProductFilterOptions = state => state.product.filterOptions

// random
export const selectRandomProducts = state => state.product.randomProducts
export const selectRandomProductCount = state => state.product.randomProductsCount
export const selectRandomProductFilterOptions = state => state.product.randomFilterOptions


export default productSlice.reducer